/* LYOVA – bodky pri posúvaní dlaždíc na mobile + prehrávanie videí zákazníkov */
(function () {
  'use strict';

  function initScrollers(root) {
    root.querySelectorAll('[data-lyova-scroller]').forEach(function (track) {
      if (track.dataset.lyovaReady) return;
      track.dataset.lyovaReady = '1';

      var dotsWrap = track.parentElement && track.parentElement.querySelector('[data-lyova-dots]');
      var items = Array.prototype.slice.call(track.children);
      if (!dotsWrap || items.length < 2) return;

      dotsWrap.innerHTML = items.map(function () { return '<span></span>'; }).join('');
      var dots = Array.prototype.slice.call(dotsWrap.children);

      function update() {
        var step = items[1].offsetLeft - items[0].offsetLeft || 1;
        var max = track.scrollWidth - track.clientWidth;
        var index = track.scrollLeft >= max - 2 ? items.length - 1 : Math.round(track.scrollLeft / step);
        dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
      }

      var frame;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(update);
      }, { passive: true });
      update();
    });
  }

  function initVideos(root) {
    root.querySelectorAll('[data-lyova-video]').forEach(function (tile) {
      if (tile.dataset.lyovaReady) return;
      tile.dataset.lyovaReady = '1';

      var video = tile.querySelector('video');
      var toggle = tile.querySelector('[data-lyova-video-toggle]');
      if (!video || !toggle) return;

      toggle.addEventListener('click', function () {
        if (video.paused) {
          document.querySelectorAll('[data-lyova-video] video').forEach(function (other) {
            if (other !== video) other.pause();
          });
          video.muted = false;
          var attempt = video.play();
          if (attempt && attempt.catch) {
            attempt.catch(function () {
              video.muted = true;
              video.play();
            });
          }
        } else {
          video.pause();
        }
      });

      video.addEventListener('play', function () {
        tile.classList.add('is-playing');
        toggle.setAttribute('aria-label', toggle.dataset.labelPause || 'Pause');
      });
      video.addEventListener('pause', function () {
        tile.classList.remove('is-playing');
        toggle.setAttribute('aria-label', toggle.dataset.labelPlay || 'Play');
      });
    });
  }

  function init(root) {
    initScrollers(root || document);
    initVideos(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
